import React from 'react';
var defaultValue = {
    padding: {
        paddingTop: 20,
        paddingRight: 24,
        paddingBottom: 24,
        paddingLeft: 24,
    },
    scroll: 'content',
    setTitle: function () { return undefined; },
};
export var DialogStylesContext = React.createContext(defaultValue);
export var useDialogStyles = function () {
    var context = React.useContext(DialogStylesContext);
    if (context === defaultValue) {
        console.error('Pigment Dialog: DialogContent, DialogActions, and useDialogTitle must be used within a Dialog component. Are you importing the correct Dialog from Pigment?');
    }
    return context;
};
export default DialogStylesContext;
//# sourceMappingURL=DialogStylingContext.js.map